// @core/api/endpoints/task/create_status_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateStatusDefinitionRequest,
  StatusDefinitionResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create status definition
 * Creates a custom status with a mapping to a base TaskStatus category. Custom statuses enable team-specific workflows (e.g., Code Review, QA Testing) while preserving universal filtering.
 */
export async function CreateStatusDefinition(
  data: CreateStatusDefinitionRequest,
  options?: RequestOptions
): Promise<StatusDefinitionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/status-definitions`;
  const requestOptions = options;
  return client.post<StatusDefinitionResponse>(requestPath, data, requestOptions);
}
